<template>
    <div>
     <transition
      appear
      @before-enter="$animations.beforeEnterLogoArea"
      @enter="$animations.enterLogoArea"
      >
      <Logo></Logo>
      </transition>

      <div class="card px-2 py-2 classCard" >
        <transition
        appear
        @before-enter="$animations.beforeEnterBelow"
        @enter="$animations.enterBelow"
        >
          <div class="columns is-6 is-centered">
            <div class="column">

<!--            <div class="button_info">-->
<!--            <div class="column">-->
<!--              <div class="column is-centered is-6 is-offset-4">-->
<!--              <div-->
<!--                  :class="` column is-8 is-offset-4 is-flex is-flex-direction-row-reverse`"-->
<!--              >-->

<!--              <b-button-->
<!--                  @click="$router.push('notice_info')"-->
<!--                  :class="`is-primary ${-->
<!--                  $root.selectedLanguage === `ta`-->
<!--                    ? `continue-button-ta`-->
<!--                    : $root.selectedLanguage === `si`-->
<!--                    ? `continue-button-si`-->
<!--                    : `continue-button-en`-->
<!--                }`" >{{ $root.selectedLanguageData.continue }}</b-button>-->

<!--                <b-button-->

<!--                    id="back-info-button"-->
<!--                    @click="$router.push(`/`)"-->
<!--                    :class="` ${-->
<!--                  $root.selectedLanguage === `ta`-->
<!--                    ? `back-button-ta`-->
<!--                    : $root.selectedLanguage === `si`-->
<!--                    ? `back-button-si`-->
<!--                    : `back-button-en`-->
<!--                }`"-->

<!--                >{{ $root.selectedLanguageData.back }}-->
<!--                </b-button>-->

<!--          </div>-->
<!--            </div>-->
<!--            </div>-->
<!--            </div>-->
            <div class="pt-5 ps-5" style="margin: 0 auto">
              <p :class="`text-center mx-3 mb-2 ${$root.selectedLanguage === `ta`
              ? `ta-he-line`
              : $root.selectedLanguage === `si`
                ? `si-he-line`
                : `en-sub-line`
              }`" style="text-align: center;font-family:OpenSans-Medium;font-size: 1.2rem " >{{ $root.selectedLanguageData.say_hello_to_the_future_of_onboarding }}</p>
              <p :class="`text-center mx-3 mb-2 ${$root.selectedLanguage === `ta`
              ? `ta-he-line`
              : $root.selectedLanguage === `si`
                ? `si-he-line`
                : `en-he-line`
              }`" style="text-align: center;font-size: 1.4rem;font-family:OpenSans-Bold;
                  line-height: 30px;
"> {{ $root.selectedLanguageData.with_RDB_Digital_Onboarding }}</p>
            </div>

            <div class="ps-5" >
            <b-carousel :pause-hover='false' style="width: 55%; margin: auto; height: 60%;"
                        :interval="5000">
              <b-carousel-item v-for="carousel in imageArray" :key="carousel.id">
                <b-image :src="carousel.imgUrl">
                </b-image>
              </b-carousel-item>
            </b-carousel>
            </div>

              <div>
                              <div class="column is-centered is-7 is-offset-3" style="padding-bottom: 8px;" >
                              <div
                                  :class="` column is-8 is-offset-4 is-flex is-flex-direction-row-reverse`"
                              >

                              <b-button
                                  @click="$router.push('notice_info')"
                                  :class="`is-primary ${
                                  $root.selectedLanguage === `ta`
                                    ? `continue-button-ta`
                                    : $root.selectedLanguage === `si`
                                    ? `continue-button-si`
                                    : `continue-button-en`
                                }`" >{{ $root.selectedLanguageData.continue }}</b-button>

                                <b-button

                                    id="back-info-button"
                                    @click="$router.push(`/`)"
                                    :class="` ${
                                  $root.selectedLanguage === `ta`
                                    ? `back-button-ta`
                                    : $root.selectedLanguage === `si`
                                    ? `back-button-si`
                                    : `back-button-en`
                                }`"

                                >{{ $root.selectedLanguageData.back }}
                                </b-button>

                          </div>
                            </div>
              </div>

          </div>
      </div>


        </transition>
      </div>


      <!-- <div class="columns is-flex-direction-row">
        <div class="column">
            <figure class="steps-img image 1by1">
                <img src="../assets/images/info_page/step_01.png">
            </figure>
        </div>
        <div class="column">
            <figure class="steps-img image 1by1">
                <img src="../assets/images/info_page/step_02.png">
            </figure>

        </div>

      </div> -->



    </div>
</template>

<script>
import Logo from "./NsbKycLogo.vue";
export default{
    components: {
    Logo,
  },
    data(){
      return{

        imageArray : [

          {
            id : 1,
            imgUrl : require(`@/assets/images/InfoPage/1.png`)
          },
          {
            id : 2,
            imgUrl : require(`@/assets/images/InfoPage/2.png`)
          },
          {
            id : 3,
            imgUrl : require(`@/assets/images/InfoPage/3.png`)
          },
          {
            id : 4,
            imgUrl : require(`@/assets/images/InfoPage/4.png`)
          },
          {
            id : 5,
            imgUrl : require(`@/assets/images/InfoPage/5.png`)
          },
        ]

      }
    }
}
</script>

<style>
.steps-img{
    width: 40%;
    height: 50%;
}
.card-style{
  background: url("../assets/images/info_bg.png") no-repeat ;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  /*font-size: 16px;*/
  margin: 0;
   height: 90vh;
  min-height: 115vh;

  /*max-height: 110%;*/
  overflow: hidden;
  /*border-radius: 70px;*/
}

.button_info{
  position: absolute;
  bottom: 20px;
  left: 680px;
}

.buttons-info {
  position: absolute;
  bottom: 20px;
  left: 280px;
  width: 100%;
  display: flex;
  /*justify-content: space-around;*/
}

#back-info-button{
  margin-left: 10px;
}

.classCard{
  width: 60%;
  max-height: 100%;
  margin: 0 auto 80px auto;
  border: #009ec2
}

@media only screen and (max-width: 500px) {
  .classCard{
    width: 80%;
    max-height: 100%;
    margin: 0 auto 80px auto;
    border: #009ec2

  }


}
</style>